import { Button, Checkbox, MenuItem, Select, type SelectChangeEvent } from '@mui/material';
import React from 'react';

/** 選択解除用の値 */
const DESELECT_ALL = 'DESELECT_ALL';

/**
 * ItemSelectDropDown コンポーネントのプロパティ
 */
type ItemSelectDropDownProps = {
    data: String[];// ドロップダウンの選択肢
    selectedValues: string[];// 現在選択されている値の配列
    onChange: (values: string[]) => void;
    width: string | number;
    variant: "outlined" | "filled" | "standard";
    renderValue: (selected: string[]) => React.ReactNode;
    showDeselectButton?: boolean; // 選択解除ボタンを表示するかどうか
    MenuProps?: any;
    disabled?: boolean;
    column?: { setFilterValue: (value: string[] | undefined) => void; };// Material React Table のカラムオブジェクト（フィルター用
}

/**
 * デバイス選択用の共通ドロップダウンコンポーネントです
 * ドロップダウンでデバイスを選択するときのUIを提供します。
 * 
 * @param ItemSelectDropDownProps - コンポーネントのプロパティ
 * @returns JSX.Element - レンダリング可能なSelectコンポーネント
 */
export default function ItemSelectDropDown(ItemSelectDropDownProps: ItemSelectDropDownProps) {
    const {
        data,
        selectedValues,
        onChange,
        width,
        variant,
        renderValue,
        column,
        showDeselectButton = false,
        MenuProps = {},
        disabled = false,
    } = ItemSelectDropDownProps;

    const handleChange = (event: SelectChangeEvent<unknown>) => {
        const { value } = event.target;
        const selectedValuesRaw: string[] = typeof value === 'string' ? [value] : value as string[];

        // 選択解除ボタンの処理
        const cleanedSelectedValues = selectedValuesRaw.filter((item) => item !== DESELECT_ALL);
        if (selectedValuesRaw.includes(DESELECT_ALL) || cleanedSelectedValues.length === 0) {
            onChange([]);
            if (column) {
                column.setFilterValue(undefined);
            }
        } else {
            onChange(cleanedSelectedValues);
            if (column) {
                column.setFilterValue(cleanedSelectedValues.length > 0 ? cleanedSelectedValues : undefined);
            }
        }
    };

    return (
        <Select
            multiple
            value={selectedValues}
            onChange={handleChange}
            sx={{ width }}
            variant={variant}
            renderValue={renderValue}
            MenuProps={MenuProps}
            disabled={disabled}
        >
            {data.map((item, i) => (
                <MenuItem key={`${i}_${item}`} value={String(item)}>
                    <Checkbox checked={selectedValues.includes(String(item))} />
                    <span>{String(item)}</span>
                </MenuItem>
            ))}

            {/* 選択解除ボタン */}
            {showDeselectButton && (
                <MenuItem
                    value={DESELECT_ALL}
                    sx={{ justifyContent: 'center' }}
                >
                    <Button
                        variant='outlined'
                        sx={{ color: 'inherit', backgroundColor: 'inherit' }}
                    >
                        選択解除
                    </Button>
                </MenuItem>
            )}
        </Select>
    );
};